<template>
    <div class="padding-normal">
        <div class="w-full overflow-hidden">
            <div class="normal-container">
                <LazyUiSlider
                    ref="slider"
                    :displayButtons="false"
                    :breakpoints="{
                        '(min-width: 0px)': {
                            slides: { perView: 'auto', spacing: 16 },
                        },
                        '(min-width: 1280px)': {
                            slides: { perView: 4, spacing: 16 },
                        },
                    }">
                    <div
                        v-for="(contactOption, index) in contactOptions"
                        :key="contactOption._key"
                        class="flex max-w-[275px] min-w-[275px] flex-col lg:max-w-[375px] lg:min-w-[375px] xl:w-full xl:max-w-full"
                        :class="['keen-slider__slide number-slide' + index]">
                        <h3 class="mb-4 lg:mb-10">{{ contactOption.title }}</h3>
                        <div class="flex flex-grow flex-col bg-green-300 p-6 lg:p-8 2xl:p-10">
                            <div
                                v-for="option in contactOption.contactOptionGroups"
                                :key="option._key"
                                class="flex 2xl:flex-grow">
                                <div class="pt-1">
                                    <IconWhatsapp v-if="option.icons == 'whatsapp'" />
                                    <IconFacebook v-if="option.icons == 'facebook'" />
                                    <IconMail v-if="option.icons == 'email'" style="fill-opacity: 0" />
                                    <IconInstagram v-if="option.icons == 'instagram'" class="!h-6 !w-6" />
                                    <IconPhone v-if="option.icons == 'phone'" style="fill-opacity: 0" />
                                </div>
                                <div class="sanity-content pl-3 break-words 2xl:break-normal">
                                    <SanityContent :blocks="option.content" />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazyUiSlider>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        title: String,
        contactOptions: {
            type: Array,
            required: true,
        },
        icon: {
            type: Object,
            required: false,
        },
        content: {
            type: Object,
            required: false,
        },
    });

    const slider = useTemplateRef('slider');
</script>

<style scoped>
    @media screen and (max-width: 500px) {
        .scroll-on-mobile {
            overflow-x: auto;
        }
    }

    .container {
        max-width: 1280px;
        margin-inline: 30px;
    }

    .container::-webkit-scrollbar {
        display: none;
    }

    .sanity-content {
        flex-grow: 1;
    }
</style>
